<template>
    <v-flex>
        <v-tooltip top>
            <v-btn fab dark small :color="bc.color_hex" slot="activator" @click="Toggle">
                <v-icon class="cc" dark>{{icon}}</v-icon>
            </v-btn>
            <span>{{ bc.family_name }}</span>
        </v-tooltip>
    </v-flex>
</template>
<script>
export default {
  props: {
    value: Array,
    bc: Object,
    artwork_id: Number,
    family_id: Number
  },
  data () {
    return {
      icon: 'done'
    };
  },
  watch: {
    value: function () {
      this.icon = this.IsSelected() ? 'done' : 'highlight_off';
    },
  },
  mounted () {
    this.icon = this.IsSelected() ? 'done' : 'highlight_off';
  },
  methods: {
    Toggle () {
      let v = this.value;
      if (this.icon === 'highlight_off') {
        v.push({
          family_id: this.family_id,
          color_family: this.bc.cf_id,
          artwork_id: this.artwork_id,
        });
        this.icon = 'done';
      } else {
        let hasThis = v.findIndex(aacf => aacf.color_family === this.bc.cf_id);
        if (hasThis > -1) {
          v = v.filter((v) => {
            return v.color_family !== this.bc.cf_id;
          });
        }
        this.icon = 'highlight_off';
      }
      this.$emit('ColorChange', v);
    },
    IsSelected () {
      let k = this.value.findIndex(aacf => aacf.color_family === this.bc.cf_id);
      if (k > -1) {
        return true;
      }
      return false;
    },
  }
};
</script>
<style>
    .cc {
        text-shadow: 0 0 1px #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/widgets/color/CircleColor.vue